var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title is-6 has-text-centered has-text-weight-bold"},[_vm._v(_vm._s(_vm.title))]),_c('div',{ref:"chart",staticClass:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }